module.exports = __webpack_public_path__ + "img/id_grey_border.263fb0cf.svg";